export const initialise = () => {
    const widgets = document.querySelectorAll<HTMLElement>('.inline-shortlist-widget')

    widgets.forEach((widget) => {
        const count = widget.querySelector<HTMLElement>('.fav-count')
        if (!count) return

        const observer = new MutationObserver(() => {
            if (count?.textContent) {
                const num = parseInt(count.textContent, 10)
                if (!isNaN(num)) {
                    count.textContent = `(${num})`
                }
            }
        })
        observer.observe(count, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['textContent'],
        })
        const countText = count?.textContent
        if (countText) {
            const num = parseInt(countText, 10)
            if (!isNaN(num)) {
                count.textContent = `(${num})`
            }
        }
    })
}